// controllers/data-loading-controller.ts
import {
  distinctUntilChanged,
  of,
  pairwise,
  shareReplay,
  startWith,
  switchMap,
  tap
} from "rxjs";
import "./chemistry-controller";
var DataLoadingController = class {
  constructor(host, triggerOrGetterFn, getterFn) {
    this.isLoading = true;
    (this.host = host).addController(this);
    getterFn = typeof triggerOrGetterFn === "function" ? triggerOrGetterFn : getterFn;
    const trigger = typeof triggerOrGetterFn === "function" ? void 0 : triggerOrGetterFn;
    this._trigger = trigger;
    this._getter = getterFn;
    if (!this._trigger)
      this.observable = of(void 0).pipe(
        switchMap(this._getter),
        tap(() => this.isLoading = false),
        shareReplay(1)
      );
    else
      this.observable = this._trigger.pipe(
        tap(() => {
          this.isLoading = true;
          if (this.propertyName)
            this.host.requestUpdate(this.propertyName, this.value);
          else
            this.host.requestUpdate();
        }),
        switchMap(this._getter),
        tap(() => this.isLoading = false),
        shareReplay(1)
      );
  }
  get propertyName() {
    if (this._propertyName !== void 0)
      return this._propertyName;
    let propertyName = Object.keys(this.host).find((propertyKey) => this.host[propertyKey] === this);
    if (!propertyName)
      return this._propertyName = null;
    if (propertyName.startsWith("__"))
      propertyName = propertyName.replace(/^__/, "");
    return this._propertyName = propertyName;
  }
  hostConnected() {
    if (!this.subscription)
      this.subscription = this.observable.pipe(
        startWith(void 0),
        distinctUntilChanged((a, b) => ![typeof a, typeof b].includes("object") && a === b),
        pairwise()
      ).subscribe(([oldValue, val]) => {
        this.value = val;
        if (this.propertyName)
          this.host.requestUpdate(this.propertyName, oldValue);
        else
          this.host.requestUpdate();
      });
  }
  hostDisconnected() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.subscription = void 0;
  }
};
export {
  DataLoadingController
};
